import React from "react";
import Button, { ButtonProps } from "@material-ui/core/Button";

export default (props: ButtonProps) => {
  const { color = "primary" } = props;
  return <Button variant="contained" {...props} color={color} />;
};
